import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=5c2474c5&scoped=true&"
import script from "./Facilities.vue?vue&type=script&lang=js&"
export * from "./Facilities.vue?vue&type=script&lang=js&"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=5c2474c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2474c5",
  null
  
)

export default component.exports